import React from "react";
import {
  BooleanInput,
  Create,
  Datagrid,
  DateField,
  Edit,
  Filter,
  List,
  NumberField,
  NumberInput,
  required,
  SimpleForm,
  TextField,
  TextInput
} from "react-admin";

// ============ Subscription Add-on Catalog Resource ============

const SubscriptionAddonListFilter = props => (
  <Filter {...props}>
    <TextInput label="Search by name" source="qName" alwaysOn />
    <TextInput label="Search by slug" source="qSlug" />
  </Filter>
);

function SelfServiceBadge({ record = {} }) {
  return record.selfService ? (
    <span style={{
      background: "#2196f3",
      color: "white",
      padding: "2px 8px",
      borderRadius: "4px",
      fontSize: "12px"
    }}>
      Yes
    </span>
  ) : (
    <span style={{
      color: "#999",
      fontSize: "12px"
    }}>
      Admin only
    </span>
  );
}

function ActiveBadge({ record = {} }) {
  return record.isActive ? (
    <span style={{
      background: "#4caf50",
      color: "white",
      padding: "2px 8px",
      borderRadius: "4px",
      fontSize: "12px"
    }}>
      Active
    </span>
  ) : (
    <span style={{
      background: "#f44336",
      color: "white",
      padding: "2px 8px",
      borderRadius: "4px",
      fontSize: "12px"
    }}>
      Inactive
    </span>
  );
}

function PriceField({ record = {} }) {
  const priceId = record.stripePriceId;
  if (!priceId) {
    return (
      <span style={{
        color: "#ff9800",
        fontStyle: "italic",
        fontSize: "12px"
      }}>
        Ad-hoc pricing
      </span>
    );
  }
  return (
    <span style={{
      background: "#e3f2fd",
      color: "#1976d2",
      padding: "2px 8px",
      borderRadius: "4px",
      fontSize: "11px",
      fontFamily: "monospace"
    }}>
      {priceId.substring(0, 24)}...
    </span>
  );
}

export function SubscriptionAddonList(props) {
  return (
    <List
      {...props}
      sort={{ field: "order", order: "ASC" }}
      filters={<SubscriptionAddonListFilter />}
      empty={false}
    >
      <Datagrid rowClick="edit">
        <TextField label="Name" source="name" />
        <TextField label="Slug" source="slug" />
        <TextField label="Description" source="description" />
        <PriceField label="Stripe Price" source="stripePriceId" />
        <NumberField label="Monthly (pence)" source="monthlyPriceCents" />
        <NumberField label="Order" source="order" />
        <ActiveBadge label="Status" source="isActive" />
        <SelfServiceBadge label="Self-Service" source="selfService" />
      </Datagrid>
    </List>
  );
}

export function SubscriptionAddonCreate(props) {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="name" label="Name" validate={[required()]} />
        <TextInput
          source="slug"
          label="Slug"
          validate={[required()]}
          helperText="Unique identifier (e.g., 'custom-email-domain')"
        />
        <TextInput source="description" label="Description" multiline fullWidth />
        <TextInput
          source="stripePriceId"
          label="Default Stripe Price ID"
          helperText="Leave empty for ad-hoc pricing (admin sets per-school price)"
          fullWidth
        />
        <NumberInput
          source="monthlyPriceCents"
          label="Monthly Price (pence)"
          defaultValue={0}
          helperText="Display price in pence, 0 if ad-hoc"
        />
        <NumberInput source="order" label="Display Order" defaultValue={0} />
        <BooleanInput source="isActive" label="Active" defaultValue={true} />
        <BooleanInput
          source="selfService"
          label="Self-Service"
          helperText="If enabled, users can toggle this add-on from the dashboard. Requires a Stripe Price ID."
        />
      </SimpleForm>
    </Create>
  );
}

export function SubscriptionAddonEdit(props) {
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput source="id" label="ID" disabled />
        <TextInput source="name" label="Name" validate={[required()]} />
        <TextInput source="slug" label="Slug" validate={[required()]} />
        <TextInput source="description" label="Description" multiline fullWidth />
        <TextInput
          source="stripePriceId"
          label="Default Stripe Price ID"
          helperText="Required for self-service add-ons. Leave empty for admin-only ad-hoc pricing."
          fullWidth
        />
        <NumberInput source="monthlyPriceCents" label="Monthly Price (pence)" />
        <NumberInput source="order" label="Display Order" />
        <BooleanInput source="isActive" label="Active" />
        <BooleanInput
          source="selfService"
          label="Self-Service"
          helperText="If enabled, users can toggle this add-on from the dashboard"
        />
        <DateField label="Created" source="createdAt" showTime />
        <DateField label="Updated" source="updatedAt" showTime />
      </SimpleForm>
    </Edit>
  );
}
